document.addEventListener("click", function (e) {
  const btn = e.target.closest(".site-header__cart-toggle");
  if (!btn) return;
  window.dispatchEvent(new Event('scroll'));
});

document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); 

const cartDrawer = document.querySelector("cart-drawer");

if (cartDrawer) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
        const isHidden = cartDrawer.getAttribute("aria-hidden");

        if (isHidden === "false") {
          setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
      }
    });
  });

  observer.observe(cartDrawer, {
    attributes: true,
  });
}

const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 
